import { baseBUCGet } from '../base/baseBUC';

const str = '';
const dateTimeStr = new Date()?.toISOString();

export const supplierModelGet = ({
    buildingId = '',
    countryId = '',
    userId = '',
}) => {
    return {
        countryId: countryId,
        address: str,
        city: str,
        date: dateTimeStr,
        description: str,
        email: str,
        national: true,
        nit: str,
        phoneNumber: str,
        rif: str,
        webSite: str,
        contactDescription: str,
        contactPhoneNumber: str,
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    }
};